import styled from 'styled-components';

export const StyledUpload = styled.div`
  margin-top: 8px;
`;
